export const p2e = (s:any) => (s.replace(/[۰-۹]/g, (d:any) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))